(function () {
  const CHECKOUT_BUTTON_SELECTOR = '[data-bodf-checkout-button], .cart__checkout-button[name="checkout"]';
  const FALLBACK_REDIRECT_DELAY = 4500;

  let activeButton = null;
  let fallbackTimer = null;

  function findStatus(button) {
    const ctas = button.closest('.cart__ctas');
    return ctas ? ctas.querySelector('[data-bodf-checkout-status]') : null;
  }

  function setStatus(button, message, isError) {
    const status = findStatus(button);
    if (!status) return;

    status.textContent = message || '';
    status.hidden = !message;
    status.dataset.state = isError ? 'error' : 'info';
  }

  function setLoading(button, isLoading) {
    button.toggleAttribute('data-bodf-checkout-loading', isLoading);
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    button.setAttribute('aria-disabled', isLoading ? 'true' : 'false');

    if (isLoading) {
      activeButton = button;
      setStatus(button, 'Redirecting to secure checkout...', false);
      return;
    }

    if (activeButton === button) {
      activeButton = null;
    }
  }

  function resetLoading() {
    if (fallbackTimer) {
      window.clearTimeout(fallbackTimer);
      fallbackTimer = null;
    }

    if (activeButton) {
      activeButton.removeAttribute('data-bodf-checkout-loading');
      activeButton.setAttribute('aria-busy', 'false');
      activeButton.setAttribute('aria-disabled', 'false');
      setStatus(activeButton, '', false);
      activeButton = null;
    }
  }

  function getForm(button) {
    return button.form || document.getElementById(button.getAttribute('form') || 'cart-form');
  }

  function ensureCheckoutInput(form) {
    let input = form.querySelector('input[name="checkout"][data-bodf-checkout-input]');

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'checkout';
      input.value = 'Checkout';
      input.dataset.bodfCheckoutInput = 'true';
      form.appendChild(input);
    }
  }

  function getCheckoutUrl() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? `${window.Shopify.routes.root}checkout`
      : '/checkout';
  }

  document.addEventListener(
    'click',
    function (event) {
      const button = event.target instanceof Element ? event.target.closest(CHECKOUT_BUTTON_SELECTOR) : null;
      if (!button) return;

      if (button.disabled || button.hasAttribute('data-bodf-checkout-loading')) {
        event.preventDefault();
        return;
      }

      const form = getForm(button);

      if (!form) {
        event.preventDefault();
        setLoading(button, true);
        window.location.assign(getCheckoutUrl());
        return;
      }

      ensureCheckoutInput(form);
      setLoading(button, true);
      fallbackTimer = window.setTimeout(function () {
        if (!document.hidden && !/\/checkouts?\b|\/checkout\b/.test(window.location.pathname)) {
          window.location.assign(getCheckoutUrl());
        }
      }, FALLBACK_REDIRECT_DELAY);
    },
    true
  );

  window.addEventListener('pagehide', resetLoading);
  window.addEventListener('pageshow', resetLoading);
})();
